<div *ngFor="let item of companies$ | async" class="company">
  <div class="company-header">
    <div class="name">
      {{ item.name }}
    </div>

    <sd-dropdown #dropdown class="options">
      <ng-template #dropdownToggler>
        <button (click)="dropdown.toggle()" class="options-button" [disabled]="isRemoveInProgress$ | async">●●●</button>
      </ng-template>

      <ng-template #dropdownContent>
        <sd-dropdown-menu (click)="dropdown.close()">
          <sd-dropdown-menu-item (click)="select(item.uid)">Переключиться</sd-dropdown-menu-item>
          <sd-dropdown-menu-item (click)="remove(item.uid)">Удалить</sd-dropdown-menu-item>
        </sd-dropdown-menu>
      </ng-template>
    </sd-dropdown>
  </div>

  <div class="company-body">
    <div *ngIf="item.inn" class="property">
      <div class="property-label">ИНН</div>
      <div class="property-value">
        {{ item.inn }}
      </div>
    </div>

    <div *ngIf="item.kpp" class="property">
      <div class="property-label">КПП</div>
      <div class="property-value">
        {{ item.kpp }}
      </div>
    </div>

    <div *ngIf="item.ogrn" class="property">
      <div class="property-label">ОГРН</div>
      <div class="property-value">
        {{ item.ogrn }}
      </div>
    </div>

    <div *ngIf="item.address" class="property">
      <div class="property-value">
        {{ item.address.formattedAddress }}
      </div>
    </div>
  </div>

  @if (item.creditContracts?.length) {
    <div class="company-footer">
      <div class="credit-contracts">
        @for (contract of item.creditContracts; track contract.id; let i = $index) {
          <div class="credit-contract text-b2-s-300">
            <div>
              договор №{{ i + 1 }} -
              @if (contract.contractAmount) {
                лимит:&nbsp;
                <div class="digits">{{ contract.contractAmount | number: '1.2-2' }}</div>
              }
            </div>
            @if (contract.contractAmount && contract.creditBalance) {
              <span>&nbsp;|</span>
            }
            <div>
              @if (contract.creditBalance) {
                &nbsp;оставшийся лимит:&nbsp;
                <div class="digits">{{ contract.creditBalance | number: '1.2-2' }}</div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<div class="add-company">
  <sd-add-company-button size="s"></sd-add-company-button>
</div>
